
    <ng-container *ngIf="item">
      <div (click)="reject()" class="icon close-popup"><i class="fal fa-times"></i></div>
      <div class="label yellow-label">welcome package promotion</div>
      <div class="_10px-spacer"></div>
      <h3>{{ item.name }}</h3>
      <img src="/assets/images/v2/withdraw-disabled.svg" height="200" />
      <p>{{ item.description }}</p>
      <app-form-button class="primary full-width" [loading]="loading" [disabled]="loading" (click)="activate()"
        >Activate bonus</app-form-button
      >
      <br />
      <app-form-button class="secondary full-width" (click)="reject()">Skip</app-form-button>
      <br />
      <a href="/legal/bonus-terms" (click)="showTerms($event)">Bonus terms & conditions</a>
    </ng-container>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/deposit-promotion-modal.component.ts.DepositPromotionModalComponent.html